export default __webpack_public_path__ + "static/media/Genesis-Currency.779308a5.svg";